module.exports = __webpack_public_path__ + "0aef63618264b7f55632842945ad8103.png";